<template>
  <div>
    <div v-show="isShowDialog">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title"><slot name="title"></slot></strong></div>
        <div class="weui-dialog__bd"><slot name="content"></slot></div>
        <div class="weui-dialog__ft">
          <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="secondOnClick"><slot name="secondly-operation"></slot></a>
          <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="mainOnClick"><slot name="main-operation"></slot></a>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
  export default{
    name: 'we-reactive-dialog',

    props: ['isShowDialog'],

    methods: {
      secondOnClick () {
        this.$emit('secondOnClick')
      },

      mainOnClick () {
        this.$emit('mainOnClick')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// WeReactiveDialog.vue?4a5c4d5d